<template>
  <div class="aboutUs">
    <header>
      <Navbar />
    </header>
    <div class="product-header">
      <div class="product_bannnerText">
        <div>关于我们</div>
        <div>
          诚招英才，职等你来，期待你的加入！天津展华科技发展有限公司，是一家专注于医疗行业信息化建设的高科技企业，已发展成为集实用创新型软件研究与开发、专业标准化实施与服务于一体的整体解决方案提供商。
        </div>
      </div>
    </div>
    <div class="aboutUsBox">
      <div class="pth">
        <div class="rerurn" @click="goRecruiment">
          <div>返回上一级</div>
          <div class="returnLeve"><img :src="returnLeve" /></div>
        </div>
      </div>
      <div class="title">
        <div>公司简介</div>
        <div class="redline"></div>
      </div>
      <div class="introductionHeader">
        <div class="introductionLeft"><img :src="introductionLeft" /></div>

        <div class="introductionRight">
          <div class="introductionTitle">
            <div>医疗行业信息化建设的高科技企业</div>
            <div><img :src="logo" /></div>
          </div>
          <div class="text">
            天津展华科技发展有限公司，是一家专注于医疗行业信息化建设的高科技企业，总部位于天津市和平区合生财富广场，在北京、新疆等地设有分公司。展华科技紧扣时代脉搏，持续走创新发展的道路，已经获得包括HIS、电子病历、集成平台、智慧医疗、综合运营管理、区域医疗等在内的数十项自主知识产权产品国家级认证。
          </div>
          <div class="text">
            展华科技拥有一支经验丰富的技术团队，以专业化软件技术为核心，为全国广大医疗卫生行业用户提供安全、可靠、高质量的医疗信息化产品和技术服务。凭借多年专注医疗信息化领域而积累的大量用户和经验，展华科技已发展成为集实用创新型软件研究与开发、专业标准化实施与服务于一体的整体解决方案提供商。
          </div>
        </div>
      </div>
      <div class="introductionFooter">
        <div
          class="introductionList"
          v-for="(item, introductIndex) in introductionList"
          :key="introductIndex"
        >
          <div class="listCont">
            <div>
              {{ item.trait1 }}<span>{{ item.trait2 }}</span>
            </div>
            <div class="line"></div>
            <div>{{ item.trait3 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutUsBox">
      <div class="idea">
        <div class="title">
          <div>核心理念</div>
          <div class="redline"></div>
          <div class="ideaText">
            <div>通过技术创新和实践经验的完美结合，</div>
            <div>
              天津展华科技发展有限公司现已发展成为掌握医疗信息核心技术并获得了众多相关自主知识产权的公司，
            </div>
            <div>也是能够提供全面的实用型解决方案的公司，</div>
            <div>
              为医疗行业用户提供一系列安全、可靠、高质量、易实施、易扩展的集成化医疗信息产品。
            </div>
            <div>
              展华科技将“共享才能共赢，品质铸就成功”作为公司经营理念和品牌承诺，
            </div>
            <div>以自主创新为基础，坚定走专业化和品质化发展道路，</div>
            <div>致力打造一流的实用创新型产品，</div>
            <div>以医疗行业用户获得最佳的产品应用体验和持续发展为己任，</div>
            <div>力争创造客户、社会价值的最大化。</div>
          </div>
        </div>
        <div class="ideafooter">
          <div><img :src="aboutUsa" /></div>
          <div><img :src="aboutUsb" /></div>
          <div><img :src="aboutUsc" /></div>
          <div><img :src="aboutUsd" /></div>
          <div><img :src="aboutUse" /></div>
        </div>
      </div>
    </div>
    <div class="aboutUsBox">
      <div class="history">
        <div class="title">
          <div>核心理念</div>
          <div class="redline"></div>
        </div>
        <div class="historyCont">
          <div class="historyList">
            <div class="historyText-left">
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div
              class="historyText-left"
              v-for="(item, leftIndex) in leftList"
              :key="leftIndex"
            >
              <div>{{ item.time }}</div>
              <div>{{ item.title }}</div>
              <div>
                {{ item.text }}
              </div>
            </div>
          </div>
          <div class="historyLine">
            <img :src="historyLine" />
          </div>
          <div class="historyList">
            <div
              class="historyText-right"
              v-for="(item, historyIndex) in rightList"
              :key="historyIndex"
            >
              <div>{{ item.time }}</div>
              <div>{{ item.title }}</div>
              <div>
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <root />
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue";
import aboutAsbanner from "../../assets/aboutAsbanner.png";
import aboutUsa from "../../assets/aboutUsa.png";
import aboutUsb from "../../assets/aboutUsb.png";
import aboutUsc from "../../assets/aboutUsc.png";
import aboutUsd from "../../assets/aboutUsd.png";
import aboutUse from "../../assets/aboutUse.png";
import logo from "../../assets/logo.png";
import introductionLeft from "../../assets/introductionLeft.png";
import historyLine from "../../assets/historyLine.png";
import returnLeve from "../../assets/returnLeve.png";
export default {
  name: "aboutUs",
  components: {
    Navbar,
    Root,
  },
  data() {
    return {
      returnLeve,
      aboutAsbanner: aboutAsbanner,
      aboutUsa: aboutUsa,
      aboutUsb: aboutUsb,
      aboutUse: aboutUse,
      aboutUsc: aboutUsc,
      aboutUsd: aboutUsd,
      introductionLeft: introductionLeft,
      logo: logo,
      historyLine: historyLine,
      introductionList: [
        { trait1: "1998", trait2: "年", trait3: "公司成立时间" },
        {
          trait1: "5000",
          trait2: "万",
          trait3: "公司注册资金",
        },
        {
          trait1: "400",
          trait2: "余家",
          trait3: "服务医疗机构",
        },
      ],
      leftList: [
        {
          time: "2004年",
          title: "展华科技成立展华天津分公司",
          text: "2004年与原展华集团建立合作关系，成立展华天津分公司。随着公司业务及市场规模的扩展，2008年更名为北京展华金卫软件有限公司。",
        },
        {
          time: "2009年",
          title: "与微软公司医疗软件事业部达成战略合作伙伴协议",
          text: "2009年与微软公司医疗软件事业部达成战略合作伙伴协议，承接部分微软医疗信息化产品的技术服务。",
        },
        {
          time: "2020年",
          title: "作为天津市和平区招商引资重点企业",
          text: "2020年，作为天津市和平区招商引资重点企业，公司重新注册于天津市和平区，更名为天津展华科技发展有限公司，立足天津面向全国，持续为全国医疗卫生领域广大用户提供HIS、电子病历、集成平台、综合运营管理、智慧医院、区域医疗等软件产品及技术服务。",
        },
      ],
      rightList: [
        {
          time: "1998年",
          title: "公司核心团队于1998年创立天津军惠公司",
          text: "公司核心团队于1998年创立天津军惠公司，是国内医疗卫生行业信息化建设的开拓者之一，先后开辟了天津、北京、黑龙江等地区医疗卫生信息化市场，为各级医疗机构提供HIS、 电子病历等软件产品和技术服务。",
        },
        {
          time: "2005年",
          title: "与原天津市卫生局成立合作",
          text: "2005年与原天津市卫生局合作，在天津地区推广展华财务、成本核算等HRP系统，成为天津市卫健委信息化建设长期合作伙伴，持续为全市400余家医疗机构提供技术服务。",
        },
        {
          time: "2012年",
          title: "公司更名为凯华国软（北京）科技有限公司",
          text: "2012年北京展华金卫软件有限公司更名为凯华国软（北京）科技有限公司，在此期间，拓展了天津、北京、黑龙江、吉林、新疆、青海、河南、广东等医疗卫生信息化市场。",
        },
      ],
    };
  },
  methods: {
    goRecruiment() {
      this.$router.push({ path: "recruiment" });
    },
  },
};
</script>
<style scoped>
footer {
  height: 520px;
  margin-top: 30px;
}
header {
  background-color: #ffffff;
}
.recruiment {
  background-color: #f5f7fa;
}
.returnLeve {
  margin-left: 10px;
}
.pth {
  margin-bottom: 30px;
  height: 22px;
}
.rerurn {
  cursor: pointer;
  position: absolute;
  right: 0;
  display: flex;
  height: 30px;
  font-size: 16px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: right;
  font-weight: 400;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/SupandSerBanner.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/aboutAsbanner.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  font-size: 18px;
  width: 70%;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.title {
  text-align: center;
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.redline {
  margin: 0 auto;
  background-color: #e52f22;
  height: 6px;
  width: 60px;
  margin-top: 20px;
  margin-bottom: 50px;
}
.aboutUsBox {
  position: relative;
  margin: 0 auto;
  margin-top: 30px;
  width: 85%;
}
.introductionHeader {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.introductionRight {
  width: 50%;
  position: relative;
}
.introductionTitle :nth-child(2) {
  position: absolute;
  right: 0;
}
.introductionTitle :nth-child(1) {
  font-size: 24px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.introductionTitle {
  display: flex;
  margin-bottom: 43px;
}
.text {
  width: 100%;
  margin-bottom: 30px;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
}
.line {
  background-color: #e52f22;
  width: 30px;
  height: 6px;
  margin-top: 28px;
}
.introductionList {
  width: 350px;
  height: 200px;
  margin-top: 50px;
  background-color: #ffffff;
  box-shadow: 0 5px 20px 0 rgba(155, 165, 181, 0.25);
}
.listCont :nth-child(1) {
  font-size: 50px;
  color: #0f1422;
  letter-spacing: 0;
  padding-top: 32px;
  font-weight: 700;
}
.introductionList :nth-child(1) span {
  font-size: 18px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 400;
}

.introductionList :nth-child(3) {
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  margin-top: 20px;
  font-weight: 400;
}
.listCont {
  width: 45%;
  margin: 0 auto;
}
.introductionFooter {
  display: flex;
  justify-content: space-between;
}
.ideaText {
  text-align: center;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
}
.ideafooter {
  display: flex;
  /* flex-wrap: wrap; */
  margin-top: 50px;
  justify-content: space-between;
}
.historyLine {
  margin-left: 20px;
  margin-right: 20px;
}
.historyCont {
  display: flex;
  /* width: 85%; */
  margin: 0 auto;
}
.historyList {
  width: 50%;
}
.historyList .historyText-left:nth-child(1) {
  height: 150px;
}
.historyText-left {
  height: 268px;
}
.historyText-left :nth-child(1) {
  font-size: 28px;
  color: #e52f22;
  letter-spacing: 0;
  text-align: right;
  font-weight: 500;
}
.historyText-left :nth-child(2) {
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  text-align: right;
  line-height: 28px;
  font-weight: 500;
}
.historyText-left :nth-child(3) {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
}

.historyText-right {
  height: 268px;
}
.historyText-right :nth-child(1) {
  font-size: 28px;
  color: #e52f22;
  letter-spacing: 0;
  text-align: left;
  font-weight: 500;
}
.historyList .historyText-right:nth-child(1) {
  margin-top: 5px;
}
.historyText-right :nth-child(2) {
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  text-align: left;
  line-height: 28px;
  font-weight: 500;
}
.historyText-right :nth-child(3) {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/index.vue